import React from 'react';

const STEPS = [
  { key: 'goals', label: '1. Targets' },
  { key: 'allocations', label: '2. Allocations' },
  { key: 'actuals', label: '3. Actuals' },
  { key: 'review', label: '4. Review' }
];

function PerformanceWorkflowStrip({ activeStep }) {
  return (
    <section className="director-card director-workflow-card">
      <div className="role-section-header">
        <h2>Performance Workflow</h2>
        <span>4 steps</span>
      </div>
      <div className="director-workflow-strip">
        {STEPS.map(step => (
          <div
            key={step.key}
            className={`director-workflow-step ${activeStep === step.key ? 'active' : ''}`}
          >
            <strong>{step.label}</strong>
          </div>
        ))}
      </div>
    </section>
  );
}

export default PerformanceWorkflowStrip;
